var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8485 15.1298L11.7175 11.0648C12.7993 9.8895 13.464 8.33512 13.464 6.62468C13.4634 2.96574 10.4497 0 6.73171 0C3.01376 0 0 2.96574 0 6.62468C0 10.2836 3.01376 13.2494 6.73171 13.2494C8.33813 13.2494 9.81149 12.6937 10.9688 11.77L15.1159 15.851C15.3179 16.0501 15.646 16.0501 15.848 15.851C16.0506 15.652 16.0506 15.3289 15.8485 15.1298ZM6.73171 12.2301C3.58592 12.2301 1.03577 9.72048 1.03577 6.62468C1.03577 3.52888 3.58592 1.01925 6.73171 1.01925C9.87753 1.01925 12.4277 3.52888 12.4277 6.62468C12.4277 9.72048 9.87753 12.2301 6.73171 12.2301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.45de4b1110d96284d21f04be6105059c.svg";
export { ForwardRef as ReactComponent };